export enum TicketView {
    formEmailApi = 1,
    socialMedia = 2,
    chat = 3,
}
